import { Box, Chip, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import React, { Fragment } from 'react'
import { Item } from '../../../interfaces/Generic/State'
import { formatExpirationDate } from '../../../utils/dateHelper'

interface ItemRowProps {
  item: Item
  onRemove: (itemName: string, batchId?: number) => void
}

export const ItemRow = ({ item, onRemove }: ItemRowProps) => {
  const shouldShowBatchInfo = item.batchNumber || item.batchExpirationDate

  return (
    <Fragment>
      <tr
        style={{ color: item.withExcess ? 'red' : '#199D03' }}
      >
        <td>{`${item.value}x `}</td>
        <td style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
          {`${item.name}`}
        </td>
        <td>
          <IconButton
            aria-label='delete'
            onClick={() => onRemove(item.name, item.batchId)}
          >
            <CloseIcon />
          </IconButton>
        </td>
      </tr>
      {shouldShowBatchInfo && (
        <tr>
          <td colSpan={3}>
            <Box
              sx={(theme) => ({
                display: 'flex',
                gap: theme.spacing(1),
                justifyContent: 'center'
              })}
            >
              {item.batchNumber && (
                <Chip
                  label={`lote ${item.batchNumber}`}
                  sx={(theme) => ({
                    backgroundColor: '#A0D2FF',
                    color: theme.palette.common.black,
                    borderRadius: theme.shape.borderRadius * 2,
                    height: 28,
                    '& .MuiChip-label': {
                      paddingLeft: theme.spacing(1),
                      paddingRight: theme.spacing(1)
                    }
                  })}
                />
              )}
              {item.batchExpirationDate && (
                <Chip
                  label={`fecha ${formatExpirationDate(
                    item.batchExpirationDate,
                    'dd-MM-yyyy'
                  )}`}
                  sx={(theme) => ({
                    backgroundColor: '#A0D2FF',
                    color: theme.palette.common.black,
                    borderRadius: theme.shape.borderRadius * 2,
                    height: 28,
                    '& .MuiChip-label': {
                      paddingLeft: theme.spacing(1),
                      paddingRight: theme.spacing(1)
                    }
                  })}
                />
              )}
            </Box>
          </td>
        </tr>
      )}
    </Fragment>
  )
}
